import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";

export interface DenyApplicationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
}

interface FormValues {
  reason: string;
}

const validationSchema = yup.object({
  reason: yup.string().trim().required("A reason for denial is required"),
});

const initialValues: FormValues = {
  reason: "",
};

export const DenyApplicationDialog: React.FC<DenyApplicationDialogProps> = ({ open, onClose, onConfirm }) => {
  const handleSubmit = async (values: FormValues) => {
    await onConfirm(values.reason.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Deny Application</DialogTitle>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {(formik) => (
          <Form>
            <DialogContent>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Please provide a reason for denying this application. This will be visible to the applicant.
              </Typography>
              <Field
                as={TextField}
                name="reason"
                label="Reason for Denial"
                fullWidth
                multiline
                rows={4}
                error={formik.touched.reason && Boolean(formik.errors.reason)}
                helperText={formik.touched.reason && formik.errors.reason}
                sx={{ mt: 2 }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <LoadingButton
                type="submit"
                variant="contained"
                color="error"
                loading={formik.isSubmitting}
                disabled={formik.isSubmitting}
              >
                Confirm Denial
              </LoadingButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default DenyApplicationDialog;
